import React from 'react';
import { Redirect } from 'react-router-dom';

import { NOTIFICATION_PREFERENCES_PATH } from 'routes';

interface Props {}

const NotificationPreferences: React.FC<Props> = () => {
  return <Redirect to={NOTIFICATION_PREFERENCES_PATH} />;
};

export default NotificationPreferences;
